import React from "react";

import pkg from "../../lib/pkg";
import { AnalyticsError } from "../../lib/util";
import {
  Integration,
  IntegrationCategory,
} from "../../providers/AnalyticsContext";
import useTrackEvent from "../useTrackEvent";
import { mapActivityListingsToProducts } from "./util";

import type { ActivityListings, Products } from "./types";

const EVENT_NAME = "Product List Viewed";

interface ProductListViewedProperties {
  category: string;
  list_id: string;
  products: Products;
}

export default function useProductListViewed() {
  const trackAdEvent = useTrackEvent(IntegrationCategory.Advertising);
  const [tracked, setTracked] = React.useState<Array<string>>([]);

  function track(
    listId: string,
    category: string,
    activityListings: ActivityListings
  ) {
    try {
      const id = listId + category;

      if (!activityListings?.length || tracked.includes(id)) {
        return;
      }

      const products = mapActivityListingsToProducts(activityListings);

      const properties: ProductListViewedProperties = {
        list_id: listId,
        category,
        products,
      };

      trackAdEvent(EVENT_NAME, properties, {
        integrations: {
          [Integration.PinterestTag]: false,
        },
      });

      setTracked([...tracked, id]);
    } catch (error) {
      pkg.onError(new AnalyticsError(EVENT_NAME, error));
    }
  }

  return React.useCallback(track, [trackAdEvent, tracked]);
}
